import { type JSX, type LazyExoticComponent, Suspense } from 'react'
import { FullPageSkeleton } from './components/ui/skeleton'

const LazyLoading = (Component: LazyExoticComponent<() => JSX.Element>) => {
  const LazyComponent = (props: Record<string, never>) => (
    <Suspense fallback={<FullPageSkeleton />}>
      <Component {...props} />
    </Suspense>
  )

  LazyComponent.displayName = `Lazy${(Component as { displayName?: string }).displayName || (Component as { name?: string }).name}`

  return LazyComponent
}

export default LazyLoading
